import React from 'react';
import { Helmet } from 'react-helmet';
import AppearingElement from "../Helper/AppearingElement";


import { Typography, Grid } from '@material-ui/core';
import { Link } from "react-router-dom";
import logo from "../images/ziplyne-logo.png"

import './main.css';
function Control_center() {
    return (
        <>
            <Helmet>
                <title>Control Center</title>
            </Helmet>
            <div className="control-center-container">
                <Grid item xs={12} sm={12} md={12} className="control-center-container-grid">
                    <AppearingElement>
                        <img src={logo} alt="logo" className="title-page__logo"></img>
                        <Typography variant="h3" className="title-page__main-text">Your Guide On The Side</Typography>
                    </AppearingElement>
                </Grid>

                <div className="control-center-links">
                    <ul>
                        <li><Link to="/pendo">Ziplyne vs. Pendo</Link></li>
                        <li><Link to="/walkme">Ziplyne vs. Walkme</Link></li>
                        <li><Link to="/whatfix">Ziplyne vs. Whatfix</Link></li>
                        <li><Link to="/application">Ziplyne ontop of an Application</Link></li>
                        <li><Link to="/salesforce">Ziplyne ontop of Salesforce</Link></li>
                        <li><Link to="/sap">Ziplyne ontop of SAP</Link></li>
                        <li><Link to="/workday">Ziplyne ontop of Workday</Link></li>
                        <li><Link to="/council">Ziplyne On A Council</Link></li>
                    </ul>
                </div>
            </div>
        </>
    )
}

export default Control_center;